import React from 'react'
import { Card, Grid, Box, Divider } from '@material-ui/core'
import { useHistory, useRouteMatch } from 'react-router-dom'
import styles from '../settingsStyles'
import PageLink from '../components/PageLink'
import AppVersion from '../components/AppVersion'
import BackButtonNavBar from '../../../CommonComponents/BackButtonNavBar/BackButtonNavBar'
import useSettingsBack from '../../../helpers/useSettingsBack'

function AppInfo() {
  const classes = styles()
  const history = useHistory()
  const goBackButton = useSettingsBack('AppInfo', '/settings')
  const { path } = useRouteMatch()

  const handleLinkPress = (link) => {
    history.push(`${path}${link}`)
  }

  return (
    <Box className={classes.settingsNavBar}>
      <BackButtonNavBar
        onClick={goBackButton}
        name="App Info"
        topMargin={{ xs: 56, sm: 64, md: 64, lg: 64 }}
      />
      <Box className={classes.centerPage}>
        <Grid
          container
          direction="column"
          alignItems="center"
          className={classes.container}
          wrap="nowrap"
        >
          <Grid item className={classes.fullWidth}>
            <Card className={classes.linksCard}>
              <PageLink
                title="Copyright Information"
                link={() => handleLinkPress('/copyrights')}
                path="/copyrights"
                section="AppInfo"
              />
              <Divider variant="middle" className={classes.fullWidth} />
              <PageLink
                title="Privacy Notices"
                link={() => handleLinkPress('/privacyNotices')}
                path="/privacyNotices"
                section="AppInfo"
              />
            </Card>
          </Grid>
          <Grid item className={classes.fullWidth}>
            <Card className={classes.linksCard}>
              <AppVersion
                versionNumber="1.4.170"
                whatsNewDescription="Widget updates, bug fixes"
              />
              <Divider variant="middle" className={classes.fullWidth} />
              <PageLink
                title="Copyright Information"
                link={() => handleLinkPress('/copyrights')}
                path="/copyrights"
                section="AppInfo"
              />
              <Divider variant="middle" className={classes.fullWidth} />
              <PageLink
                title="Privacy Notices"
                link={() => handleLinkPress('/privacyNotices')}
                path="/privacyNotices"
                section="AppInfo"
              />
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default AppInfo
